import Spinner from "../misc/Spinner";
import { clsx } from "clsx";

export interface ButtonNewProps {
  onClick: () => any;
  className?: string;
  children: JSX.Element | string | string[];
  loading?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'silver' | 'premium' | 'login' | 'giftcard--redeem' | 'text';
}

const ButtonNew = (props: ButtonNewProps) => {
  const variant = props.variant || 'primary';
  return (
    <button
      onClick={() => {
        if (props.loading || props.disabled) {
          return;
        }
        props.onClick();
      }}
      disabled={props.loading || props.disabled}
      className={clsx(
        "inline-block",
        "tracking-[0.22px]",
        "rounded-full",
        "px-[1.2rem] py-[0.7rem] sm:px-[1.4rem] sm:py-[0.7rem]",
        "text-[0.95rem] sm:text-[1.1rem] leading-[1.1rem] sm:leading-[1.4rem]",
        "transition-all duration-200",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variant === 'primary' && [
          "font-semibold border-2",
          "bg-gradient-to-b from-[rgba(218,131,41,0.05)] to-[rgba(218,131,41,0.1)]",
          "text-[#68431c] border-[#55402a]",
          "hover:bg-gradient-to-b hover:from-[rgba(218,131,41,0.08)] hover:to-[rgba(218,131,41,0.15)]",
          "transition duration-300 ease-out"
        ],
        variant === 'secondary' && [
          "font-semibold",
          "text-[#68431c] px-0 py-0 pt-0 pb-0 border-none",
          "text-[1rem] leading-[1.2rem] tracking-[-0.22px] font-medium",
        ],
        variant === 'giftcard--redeem' && [
          "font-medium border-2",
          "bg-[linear-gradient(180deg,rgba(214,195,174,0.1)_32.97%,rgba(182,160,137,0.15)_100.83%)]",
          "text-[#786857] border-[#CCC1B9]",
        ],
        variant === 'login' && [
          "font-semibold border-2",
          "bg-[linear-gradient(180deg,rgba(196,126,55,0.11)_32.97%,rgba(182,118,52,0.3)_100.83%)]",
          "text-[#68431c] border-[#55402a]",
          "hover:bg-gradient-to-b hover:from-[rgba(218,131,41,0.08)] hover:to-[rgba(218,131,41,0.15)]",
          "transition duration-300 ease-out"
        ],
        variant === 'text' && [
          "font-normal",
          "px-[0rem] pt-[0.5rem] pb-[0rem]",
          "text-[#6E4A24] text-[0.9rem] leading-[1.2rem] tracking-[-0.22px]",
        ],
        variant === 'silver' && [
          "font-semibold border-2",
          "text-[#68431c]",
          "border-2 border-[#68431c] rounded-full",
          "bg-[linear-gradient(180deg,rgba(207,152,93,0.1)_32.97%,rgba(174,113,50,0.15)_100.83%)]",
        ],
        variant === 'premium' && [
          "font-semibold border-2",
          "text-[#68431c]",
          "border-2 border-[#68431c] rounded-full",
          "bg-[linear-gradient(180deg,rgba(225,119,7,0.13)_32.97%,rgba(229,117,2,0.2)_100.83%)]",
        ],

        props.className
      )}
      type="button"
    >
      {props.loading ? (
        <Spinner className="flex flex-row justify-center" size={5} />
      ) : (
        props.children
      )}
    </button>
  );
};

export default ButtonNew;